import { defineComponent as h, useSlots as b, useCssModule as v, computed as e, openBlock as B, createBlock as $, resolveDynamicComponent as k, normalizeClass as w, unref as r, withCtx as z, renderSlot as a } from "vue";
import O from "../../utils/mapClasses.mjs";
import S from "../../props/size.mjs";
import { buildBooleanClass as W, responsiveModifyClass as M } from "../../utils/buildClass.mjs";
import i from "../../utils/propValidator.mjs";
const l = "cdr-button", j = /* @__PURE__ */ h({
  name: "CdrButton",
  __name: "CdrButton",
  props: {
    /**
       * Renders CdrButton as a <button> or <a> element. When using the value of <a>, this element renders as an anchor link.
       * @demoIgnore true
       * @values button, a
       */
    tag: {
      type: String,
      default: "button",
      validator: (t) => i(t, ["button", "a"])
    },
    /**
     * Sets the button type
     * @demoIgnore true
     * @values button, submit, reset
     */
    type: {
      type: String,
      default: "button",
      validator: (t) => i(t, ["button", "submit", "reset"])
    },
    /**
     * Modifies the style variant for this component
     * @demoSelectMultiple false
     * @values primary, secondary, sale, dark, link
     */
    modifier: {
      type: String,
      default: "primary",
      validator: (t) => i(t, ["primary", "secondary", "sale", "dark", "link"])
    },
    /**
     * Sets the button size; values can target responsive breakpoints. Example: `large@sm`.
     * @demoSelectMultiple false
     * @values small, medium, large
     */
    size: S,
    /**
     * Sets button width to 100%. Setting this value to true will set the button width to 100% of the parent container. Use the 'fullWidth' prop with the 'size' prop to control top and bottom padding.
     */
    fullWidth: {
      type: [String, Boolean],
      default: !1,
      validator: (t) => typeof t == "string" ? i(t, ["@xs", "@sm", "@md", "@lg"], !1) : typeof t == "boolean"
    },
    /**
     * Renders an 'icon-only' button. When this value is true, it will override the size and 'responsiveSize' props. Can be used in conjunction with 'with-background'
     */
    iconOnly: {
      type: Boolean,
      default: !1
    },
    /**
     * Renders an 'icon-only' button with a background color and border. Must be used in conjunction with the 'iconOnly' prop.
     */
    withBackground: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const o = t, s = b(), u = v(), c = e(() => o.tag === "button" ? o.type : null), d = e(() => `${l}--${o.modifier}`), f = e(() => !o.iconOnly && o.fullWidth ? W(l, o.fullWidth, "full-width") : ""), p = e(() => o.iconOnly ? `cdr-button--icon-only-${o.size}` : M(l, "", o.size)), m = e(() => s["icon-left"] && s.default ? `${l}--has-icon-left` : ""), y = e(() => s["icon-right"] && s.default ? `${l}--has-icon-right` : ""), C = e(() => o.iconOnly ? `${l}--icon-only` : ""), g = e(() => o.iconOnly && o.withBackground ? `${l}--with-background` : "");
    return (n, P) => (B(), $(k(t.tag), {
      class: w(r(O)(r(u), l, d.value, p.value, f.value, C.value, m.value, y.value, g.value)),
      type: c.value
    }, {
      default: z(() => [a(n.$slots, "icon-left"), a(n.$slots, "icon"), a(n.$slots, "default"), a(n.$slots, "icon-right")]),
      _: 3
    }, 8, ["class", "type"]));
  }
});
export {
  j as default
};
